<template>
  <div
    class="step-questions-actions"
    v-bind:class="{
      'max-sm:fixed max-sm:bottom-[20px] max-sm:w-full max-sm:left-0 max-sm:pl-[20px] max-sm:pr-[20px]':
        shouldShowStickyNextButton,
    }"
  >
    <button v-on="$listeners" class="next-question" :disabled="loading">
      <template v-if="!loading">
        Next question
        <amp-img
          noloading="noloading"
          class="share-icons"
          src="/resources/img/icons/white_right_arrow.svg"
          alt=""
          width="26"
          height="16"
        />
      </template>
      <img
        v-else
        loading="eager"
        src="https://www.medexpress.co.uk/images/medexpress-resources/svg/dot-loader.svg"
        alt="Loading"
        width="30"
        height="30"
      />
    </button>
  </div>
</template>

<script lang="ts">
import experiment from "amplitude-experiment";

export default {
  name: "NextQuestionButton",
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    shouldShowStickyNextButton() {
      return experiment.variant("sticky-consultation-button-on-mobile").value === "variant";
    },
  },
};
</script>

<style scoped>
.next-question:disabled {
  min-height: 70px;
}
</style>
